window.is_empty = (obj) => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}


window.moneyFormat = (number, token="Rs.", code="PKR", format=false) => {
    let value = parseFloat(number)
    if(!format)
        return token+(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    else
        return code + " " + token+(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


window.activity_types = {
    "Video": 'VIDEO',
    "Audio" : 'AUDIO', 
    "Document": 'DOCUMENT',
    "Flash Cards": "CARDS",
    'Text': "TEXT",
    'Quiz': 'QUIZ'
}

